import React from 'react';
import {useEffect} from 'react'
import '../Assets/Additionalcss/Foundationcss.css'
import foundationlogo from '../Assets/Images/found.jpg'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify';
import { ClipLoader,PulseLoader,FadeLoader} from 'react-spinners';

function Foundationsidebar({openLogout, sidebar}) {

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");


    // function ActiveIndicator(){

    //   document.getElementById("activity-indicator").style.display = "block";
     
    //  }



//       function Confirm() {

       
//         localStorage.clear();
   

//       }


// function Cancel() {

//    document.getElementById("modalRegisterForm").style.display = "none";
       

//       }
       
function toggleLogout(){

    document.getElementById("modalLogoutForm").style.display = "block";

   }

   
   function Confirm() {

       
    localStorage.clear();


  }

  function Cancel() {

    document.getElementById("modalRegisterForm").style.display = "none";
       
    
      }
    
       function closeForm()
    {
       document.getElementById("modalLogoutForm").style.display = "none";
     
     }


    useEffect(()=>{
        
         var role=localStorage.getItem('RoleId');

        if (role==='00'){

           document.getElementById("Found-Adduser").style.display="none"
           document.getElementById("Found-Assign").style.display="none"

        }
        else if (role==='01'){

            document.getElementById("Found-Adduser").style.display="block"
            document.getElementById("Found-Assign").style.display="block"
 
         }
         else { 

            document.getElementById("Found-Adduser").style.display="none"
            document.getElementById("Found-Assign").style.display="none"
 
         }
       },[]);


// function openForm()
// {
//    document.getElementById("modalLogoutForm").style.display = "block";
// }


 
// function closeForm()
// {
//    document.getElementById("modalLogoutForm").style.display = "none";
 
//  }




    return (
        <div  className ={sidebar ? "kdpfound-sidebar kdpfound-sidebar--open" : "kdpfound-sidebar"}  id="kdpfound-sidebar">
        <div className='kdpfound-sidebar-title'>
            <div className='kdpfound-sidebar-img'>
                {/* <img src={foundationlogo} alt="logo"/>&nbsp; &nbsp; */}
                <span>KDP Foundation</span>
            </div>
      
        </div>
    
       <div className='kdpfound-sidebar-menu'>
    
       <div className={splitLocation[1] === "FoundAdduser" ? "active-found" :
          splitLocation[1] === "FoundAddRole" ? "active-found" :
          splitLocation[1] === "FoundEditPop" ? "active-found" :
          "kdpfound-sidebar-link"} id="Found-Adduser">
        <i class="fa-solid fa-user-plus"></i>
            <Link to="/FoundAdduser">Users</Link>
        </div>
        <div className={splitLocation[1] === "Foundprofile" ? "active-found" : "kdpfound-sidebar-link"} >
        <i class="fa-solid fa-user"></i>
            <Link to="/Foundprofile">Profile</Link>
        </div>

        <div className={splitLocation[1] === "FoundSection"? "active-found" :
           splitLocation[1] === "FoundSectionHome"? "active-found" :
           splitLocation[1] === "FoundSectionWhoweare"? "active-found" :
           splitLocation[1] === "FoundSectionJS"? "active-found" :
           splitLocation[1] === "FoundSectionDifferentiators"? "active-found" :
           splitLocation[1] === "FoundSectionMainContributors"? "active-found" :
           splitLocation[1] === "FoundSectionFS"? "active-found" : 
           splitLocation[1] === "FoundSectionDWH"? "active-found" : 
           splitLocation[1] === "FoundSectionWWH"? "active-found" : 
           splitLocation[1] === "FoundSectionBPF"? "active-found" : 
           splitLocation[1] === "FoundSectionContributors"? "active-found" : 
           splitLocation[1] === "FoundSectionContact"? "active-found" : 
           splitLocation[1] === "FoundSectionOM"? "active-found" :
           splitLocation[1] === "FoundSectionOF"? "active-found" :
           splitLocation[1] === "FoundSectionET"? "active-found" :
           splitLocation[1] === "FoundSectionEI"? "active-found" :
           splitLocation[1] === "FoundSectionOD"? "active-found" :
            "kdpfound-sidebar-link"}>
        <i class="fa-solid fa-section"></i>
            <Link to="/FoundSection">Section</Link>
        </div>


        <div className={splitLocation[1] === "FoundAssign" ? "active-found" : "kdpfound-sidebar-link"}id="Found-Assign">
        <i class="fas fa-tasks"></i>
            <Link to="/FoundAssign">Assign</Link>
        </div>
    
        <div className='kdpfound-sidebar-link'>
        <i class="fa-solid fa-right-from-bracket"></i>
            <Link onClick={openLogout}>Logout</Link>
        </div>
       
        
       </div>
   
    <ToastContainer
     id="toast"
     position="top-center"
     autoClose={1500}
     hideProgressBar={false}
     newestOnTop={false}
     closeOnClick
     rtl={false}
     pauseOnFocusLoss
    draggable
    pauseOnHover
   />

  {/* <div className='foundation-pop-fade' id="activity-indicator">
      <FadeLoader id='activity' 
       color={'white'}
       width={5}
       height={15}
       aria-label="Loading Spinner"
       data-testid="loader"
       />
      </div> */}


    
        </div>
    );
}

export default Foundationsidebar;